const CREDIT_REQUEST_ATTEMPTS_LIMIT = 3

export const getCreditRequestAttemptsMeta = (data = {}) => {
  const attemptsStatus = data?.resubmit_attempts_status
  const totalAttempts = Math.max(1, Number(attemptsStatus?.total) || CREDIT_REQUEST_ATTEMPTS_LIMIT)
  const rawAttempts =
    attemptsStatus?.attempt ??
    data?.credit_request_attempts ??
    data?.enabled_for_resubmit?.resubmit_attempts ??
    0

  const attemptsUsed = Math.max(0, Math.min(Number(rawAttempts) || 0, totalAttempts))
  const attemptsRemaining = Math.max(totalAttempts - attemptsUsed, 0)
  const fallbackTooltip = `Evidence submissions remaining: ${attemptsRemaining} of ${totalAttempts}`
  const tooltip = attemptsStatus?.text || fallbackTooltip

  if (attemptsUsed >= totalAttempts) {
    return {
      value: `${totalAttempts} of ${totalAttempts}`,
      tooltip,
      className: "credit-request-attempts credit-request-attempts--danger",
      tooltipIconType: "circle_info",
      tooltipIconColor: "#27272A",
      attemptsUsed,
      attemptsRemaining,
      formAlertMessage:
        "ℹ️Credit attempts remaining: 0 You have no attempts remaining. This case is closed"
    }
  }

  if (attemptsRemaining === 1) {
    return {
      value: `${attemptsUsed} of ${totalAttempts}`,
      tooltip,
      className: "credit-request-attempts credit-request-attempts--warning",
      tooltipIconType: "circle_info",
      tooltipIconColor: "#27272A",
      attemptsUsed,
      attemptsRemaining,
      formAlertMessage:
        "Credit attempts remaining: 1 You have 1 attempt remaining to submit new supporting evidence"
    }
  }

  if (attemptsUsed === 1) {
    return {
      value: `${attemptsUsed} of ${totalAttempts}`,
      tooltip,
      className: "credit-request-attempts",
      tooltipIconType: "triangle_exclamation2",
      tooltipIconColor: "#DF7009",
      attemptsUsed,
      attemptsRemaining,
      formAlertMessage:
        "Credit attempts remaining: 2 You have 2 attempts remaining to submit new supporting evidence"
    }
  }

  return {
    value: `${attemptsUsed} of ${totalAttempts}`,
    tooltip,
    className: "credit-request-attempts",
    tooltipIconType: "triangle_exclamation2",
    tooltipIconColor: "#D71313",
    attemptsUsed,
    attemptsRemaining,
    formAlertMessage:
      "Credit attempts remaining: 3 Submit your evidence. If rejected, you can submit new supporting evidence up to 2 more times"
  }
}
